import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Input from '@dc/ui-library/src/molecules/Input/Input';

class CompareSessionStorageProducts extends React.PureComponent {
  renderHiddenInputs() {
    return this.props.products.map((product) => (
      <Input
        type={'hidden'}
        name={'compare[]'}
        value={product.id}
        id={`product-${product.id}`}
        key={product.id}
      />
    ));
  }

  render() {
    return (
      <span>
        {this.renderHiddenInputs()}
      </span>
    );
  }
}

CompareSessionStorageProducts.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object)
};

CompareSessionStorageProducts.defaultProps = {
  products: []
};

function mapStateToProps(state) {
  const currentPageSegmentId =
    window.digitalData.page.category &&
    window.digitalData.page.category.segmentId;
  return {
    products: state.listingPage.comparison.products[currentPageSegmentId] || []
  };
}

export default connect(mapStateToProps)(CompareSessionStorageProducts);
